import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { LeadTypes } from '@utils/enums';

import { MarketingCopyProps } from '../index';
import AppDownloadModal from '../modals/AppDownloadModal';
import CtaButtonModal from '../modals/CtaButtonModal';
import LeadCaptureModal from '../modals/LeadCaptureModal';
import LeadCaptureModalSplitImg from '../modals/LeadCaptureModalSplitImg';
import LeadCaptureModalWithHorizontalArticles from '../modals/LeadCaptureModalWithHorizontalArticles';
import LeadCaptureModalWithSingleArticle from '../modals/LeadCaptureModalWithSingleArticle';
import LeadCaptureModalWithVerticalArticles from '../modals/LeadCaptureModalWithVerticalArticles';

export enum ModalType {
  CustomUrl = 'custom_url',
  LeadCapture = 'lead_capture',
  LeadCaptureModalWithVerticalArticles = 'lead_capture_modal_with_vertical_articles',
  LeadCaptureModalWithHorizontalArticles = 'lead_capture_modal_with_horizontal_articles',
  LeadCaptureWithSingleArticle = 'lead_capture_with_single_article',
  LeadCaptureWithSplitImg = 'lead_capture_with_split_img',
  StandardOffer = 'standard_offer',
  AppDialog = 'app_dialog',
}

const queryClient = new QueryClient();

const MarketingCopy = ({
  leadType = LeadTypes.MarketingModal,
  modalType,
  onClose,
  ...restProps
}: MarketingCopyProps): JSX.Element => {
  const getModalByType = (modalType: ModalType) => {
    switch (modalType) {
      case ModalType.LeadCapture:
        return <LeadCaptureModal leadType={leadType} modalType={modalType} {...restProps} />;
      case ModalType.LeadCaptureModalWithVerticalArticles:
        return (
          <LeadCaptureModalWithVerticalArticles
            leadType={leadType}
            modalType={modalType}
            {...restProps}
          />
        );
      case ModalType.LeadCaptureModalWithHorizontalArticles:
        return (
          <LeadCaptureModalWithHorizontalArticles
            modalType={modalType}
            leadType={leadType}
            {...restProps}
          />
        );
      case ModalType.LeadCaptureWithSingleArticle:
        return (
          <LeadCaptureModalWithSingleArticle
            leadType={leadType}
            modalType={modalType}
            {...restProps}
          />
        );
      case ModalType.LeadCaptureWithSplitImg:
        return (
          <LeadCaptureModalSplitImg leadType={leadType} modalType={modalType} {...restProps} />
        );
      case ModalType.CustomUrl:
      case ModalType.StandardOffer:
        return <CtaButtonModal modalType={modalType} {...restProps} />;
      case ModalType.AppDialog:
        return <AppDownloadModal onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <QueryClientProvider client={queryClient}>{getModalByType(modalType)}</QueryClientProvider>
  );
};

export default MarketingCopy;
